module.exports = __webpack_public_path__ + "assets/img/face_crux_scene2.dd8a5a4a.png";